import { MoonIcon, SunIcon } from '@heroicons/react/24/outline'
import { useEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'

type Props = {
  className?: string
}

export function ThemeToggle({ className }: Props) {
  const [isdark, setIsdark] = useState<boolean>(
    JSON.parse(localStorage.getItem('isdark') || 'true'),
  )
  useEffect(() => {
    localStorage.setItem('isdark', JSON.stringify(isdark))
    window.document.documentElement.setAttribute(
      'data-theme',
      isdark ? 'dark' : 'light',
    )
  }, [isdark])
  return (
    <label className="swap swap-rotate">
      <input
        type="checkbox"
        className="theme-controller"
        checked={isdark}
        onChange={(e) => setIsdark(e.target.checked)}
      />
      <SunIcon className={twMerge('size-6 swap-off', className)} />
      <MoonIcon className={twMerge('size-6 swap-on', className)} />
    </label>
  )
}
